$(function() {
    const SMALL_SCREEN_BREAKPOINT = 350;
    const FULL_PLACEHOLDER = 'Enter your Location, City/County';
    const SHORT_PLACEHOLDER = 'Enter location';

    function updateLocationPlaceholder() {
        const $select2 = $('.location-form .select2-selection__placeholder');
        if ($select2.length) {
            const placeholder = $(window).width() <= SMALL_SCREEN_BREAKPOINT ? SHORT_PLACEHOLDER : FULL_PLACEHOLDER;
            $select2.text(placeholder);
        }
    }
    updateLocationPlaceholder();
    $(window).on('resize', updateLocationPlaceholder);
});